import { EndOfJourneyQuestion } from '../../lib/types/models/end-of-journey-template/end-of-journey-question'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type ReOrderEndOfJourneyQuestionInput = {
  templateId: number
  input: {
    questionId: number
    order: number
  }[]
}

export function reorderEndOfJourneyQuestion(data: ReOrderEndOfJourneyQuestionInput) {
  const { templateId, input } = data
  return restApiClient
    .url(constructApiUrl(API['end-of-journey-templates'].reorderQuestions.url, { id: templateId }))
    .patch<EndOfJourneyQuestion>(input)
}
